import "./style.scss"

$(document).ready(function(){
    if (((location.hostname).indexOf('uatts.cigna.com.hk')>=0) || (location.hostname).indexOf('dcuat.dclook.com') >= 0) {
        $('<!-- Google Tag Manager (noscript)--><noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5C43F6" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript><!-- End Google Tag Manager (noscript)-->').appendTo('body');
    } else {
        $('<!-- Google Tag Manager (noscript)--><noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-M575L42" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript><!-- End Google Tag Manager (noscript)-->').appendTo('body');
    }
    
    var currentPage = window.location.pathname.split("/").pop();
    if ( ((location.hostname).indexOf('cigna.dclook.com') >= 0) || ((location.hostname).indexOf('localhost') >= 0)  ) {
        if ($('body').hasClass('en')){
            $("a.lang").attr("href", "../zh-hant/"+ currentPage);
        }else {
            $("a.lang").attr("href", "../en/"+ currentPage);
        }
    } else {
        if ($('body').hasClass('en')){
            $("a.lang").attr("href", "/zh-hant/"+ currentPage);
        }else {
            $("a.lang").attr("href", "/en/"+ currentPage);
        }
    }
    $(window).on('resize',function() {
        if ($(window).width() < 769) {
            //$('.index header .icon #lang').prependTo('nav:not(.m-menu)');
            $('.index header .icon').insertAfter('nav:not(.m-menu) .close');
        } else {
            //$('.index nav:not(.m-menu) #lang').insertAfter('header .icon .linkedin');
            $('.index nav:not(.m-menu) .icon').prependTo('header')
        }
    }).resize();

    var headerTop = $('header').offset().top;
    $(window).on('scroll resize',function() {
        if (($(window).width() < 768) && ($(window).scrollTop() > headerTop)) {
            $('header').addClass('fixed');
        } else {
            $('header').removeClass('fixed');
        }
    }).trigger('resize');

    $('.icon_mobilemenu').on('click', function() {
        $('nav').css({
            'right': '0',
            'opacity': '1'
        }).addClass('active');
    });
    $('nav .close').on('click', function() {
        $('nav').css({
            'right': '',
            'opacity': ''
        }).removeClass('active');
    });
    $('a.contact').on('click',function(){
        if($(this).hasClass('active')){
            $('.phone').hide();
            $('a.contact').removeClass('active');
        }else{
            $('.phone').show();
            $('a.contact').addClass('active');
        }
        
    })


    $(window).on('resize',function() {
        if($(window).width() < 769){
            //$('<nav class="m-menu"><ul><li class="init">JUMP TO A SECTION<i></i></li><li><a href="javsacript:void(0);" data-anchor="caremanager">Care Manager Service</li><li><a href="javsacript:void(0);" data-anchor="ournetwork">Network</a></li><li><a href="javsacript:void(0);" data-anchor="insurtechservices">Innovative Insuretech</a></li></ul></nav>').insertAfter('header');
            $(".m-menu ul").on("click", ".init", function() {
                $(this).closest("ul").children('li:not(.init)').toggle();
                if($('.m-menu ul li:not(.init)').css('display') != 'none'){
                    $('.init i').css({'border-width': '2px 0px 0px 2px'})
                }else{
                    $('.init i').css({'border-width': '0 2px 2px 0'})
                }
            });
            
            var allOptions = $(".m-menu ul").children('li:not(.init)');
            $(".m-menu ul").on("click", "li:not(.init)", function() {
                allOptions.removeClass('selected');
                $(this).addClass('selected');
                $(".m-menu ul").children('.init').html($(this).html());
                $('<i></i>').appendTo('.init');
                allOptions.toggle();
            });

        }
    }).resize();


});